<template>
  <div class="card__meta | flex">
    <time
      class="card__date | text-grey-700"
      :datetime="dayjs(date).format('YYYY-M-DD')"
      >{{ dayjs(date).locale(locale).format("DD MMMM YYYY") }}</time
    >
  </div>
</template>

<script setup>
import dayjs from "dayjs";
import "dayjs/locale/fr";
import "dayjs/locale/en";
import { useI18n } from "vue-i18n";

const { date } = defineProps({ date: String });
const { locale } = useI18n();
</script>
